function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-brand-purple-dark">
      <div className="mx-auto max-w-content px-6 py-12">
        <div className="grid gap-8 md:grid-cols-3">
          {/* Brand */}
          <div>
            <span className="font-heading text-2xl font-light tracking-widest text-white">
              ISHI
            </span>
            <p className="mt-3 max-w-xs font-body text-sm leading-relaxed text-white/60">
              Empowering complex cardiac care everywhere. Leading the future of
              cardiac care with innovative technology, clinical excellence, and
              coordinated support.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold uppercase tracking-wider text-white/80">
              Company
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://ishi.health"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-body text-sm text-white/60 transition-colors hover:text-white"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="https://ishi.health"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-body text-sm text-white/60 transition-colors hover:text-white"
                >
                  For Patients
                </a>
              </li>
              <li>
                <a
                  href="https://ishi.health"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-body text-sm text-white/60 transition-colors hover:text-white"
                >
                  For Clinical Partners
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold uppercase tracking-wider text-white/80">
              Careers
            </h4>
            <p className="font-body text-sm leading-relaxed text-white/60">
              Interested in joining our team? Browse our open positions and find
              the role that fits you.
            </p>
            <a
              href="mailto:careers@ishi.health"
              className="mt-3 inline-block font-body text-sm font-medium text-brand-gold transition-colors hover:text-white"
            >
              careers@ishi.health
            </a>
          </div>
        </div>

        {/* E-Verify */}
        <div className="mt-10 border-t border-white/10 pt-6">
          <h4 className="mb-3 font-heading text-sm font-semibold uppercase tracking-wider text-white/80">
            E-Verify
          </h4>
          <p className="font-body text-xs leading-relaxed text-white/60">
            Ishi Health participates in the federal E-Verify program to confirm
            the identity and employment authorization of all newly hired
            employees. In accordance with federal law, we provide the Social
            Security Administration (SSA) and, if necessary, the Department of
            Homeland Security (DHS) with information from each new
            employee&apos;s Form I-9 to confirm work authorization.
          </p>
          <p className="mt-2 font-body text-xs leading-relaxed text-white/60">
            Please review the official posters for more information:
          </p>
          <ul className="mt-2 space-y-1">
            <li>
              <a
                href="https://contact.ishi.health/EVerifyParticipationPoster.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="font-body text-xs text-brand-gold transition-colors hover:text-white"
              >
                E-Verify Participation Poster (English &amp; Spanish)
              </a>
            </li>
            <li>
              <a
                href="https://contact.ishi.health/IER_RightToWorkPoster%20Eng_Es.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="font-body text-xs text-brand-gold transition-colors hover:text-white"
              >
                Right to Work Poster (English &amp; Spanish)
              </a>
            </li>
          </ul>
        </div>

        <div className="mt-8 border-t border-white/10 pt-6 text-center">
          <p className="font-body text-xs text-white/40">
            &copy; {currentYear} ISHI Health. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
